import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-sm bg-white" }

import OpeningHoursTableRow from "./OpeningHoursTableRow.vue";

  
export default {
  __name: 'OpeningHoursTable',
  props: {
    items: { type: Array, required: true },
  },
  setup(__props) {

  const props = __props;

  const fields = [
    { key: "dayOrDate", label: "Tag/Datum", width: "30%" },
    { key: "time", label: "Öffnungszeiten", width: "30%" },
  ];

  if (props.items[0]?.specificDate) {
    fields.push({ key: "specificDate", label: "Bemerkung", width: "30%" });
    fields.push({ key: "specificDate", label: "", width: "10%" });
  } else {
    fields.push({ key: "validity", label: "Gültigkeitszeitraum", width: "40%" });
  }

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fields, (field) => {
          return _createElementVNode("th", {
            key: field.key,
            style: _normalizeStyle('width: ' +field.width)
          }, _toDisplayString(field.label), 5 /* TEXT, STYLE */)
        }), 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
        return (_openBlock(), _createBlock(OpeningHoursTableRow, {
          key: item.id,
          item: item
        }, null, 8 /* PROPS */, ["item"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

}